var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CommonDialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: _vm.$t("home.dialog.login.title"),
        buttons: _vm.buttons,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "button-click": _vm.handleButtonAction,
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "text-center" }, [
        _vm.loginStep === 1
          ? _c("div", [
              _c("p", { staticClass: "text-sm text-gray-600 mb-6" }, [
                _vm._v(_vm._s(_vm.$t("home.dialog.login.registerDesc"))),
              ]),
              _c("div", { staticClass: "mb-4" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  staticClass:
                    "w-full h-12 px-4 border border-gray-200 rounded-lg text-sm",
                  attrs: {
                    type: "email",
                    placeholder: _vm.$t("home.dialog.login.codePlaceholder"),
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm.loginStep === 2
          ? _c("div", [
              _vm.loginType === "code"
                ? _c("div", [
                    _c("p", { staticClass: "text-sm text-gray-600 mb-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("home.dialog.login.codeDesc")) + " "
                      ),
                      _c("span", { staticClass: "text-blue-500" }, [
                        _vm._v(_vm._s(_vm.email || "your@email.com")),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("home.dialog.login.codeDesc2")) +
                          " "
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex justify-center space-x-2 mb-4" },
                      _vm._l(4, function (i) {
                        return _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.verificationCode[i - 1],
                              expression: "verificationCode[i - 1]",
                            },
                          ],
                          key: i,
                          ref: `codeInput${i - 1}`,
                          refInFor: true,
                          staticClass:
                            "w-12 h-12 border border-gray-300 rounded text-center text-lg",
                          attrs: { type: "text", maxlength: "1" },
                          domProps: { value: _vm.verificationCode[i - 1] },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.verificationCode,
                                  i - 1,
                                  $event.target.value
                                )
                              },
                              function ($event) {
                                return _vm.handleCodeInput($event, i - 1)
                              },
                            ],
                            keydown: function ($event) {
                              return _vm.handleKeyDown($event, i - 1)
                            },
                          },
                        })
                      }),
                      0
                    ),
                    _c(
                      "p",
                      { staticClass: "text-xs text-gray-400 mb-4" },
                      [
                        _c("van-icon", {
                          staticClass: "mr-1",
                          attrs: { name: "warning-o", size: "12" },
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("home.dialog.login.codeTip")) +
                            " "
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("div", [
                    _c(
                      "div",
                      { staticClass: "mb-4 flex flex-col items-left" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password",
                            },
                          ],
                          staticClass:
                            "w-full h-12 px-4 border border-gray-200 rounded-lg text-sm",
                          attrs: {
                            type: "password",
                            placeholder: _vm.$t(
                              "home.dialog.login.passwordPlaceholder"
                            ),
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.password = $event.target.value
                            },
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-fit mt-4 pb-0.5 inline-block text-sm text-orange-500 text-left border-b border-dashed border-orange-500",
                            on: { click: _vm.switchToCodeLogin },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("home.dialog.login.codeLogin")) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }